import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-target-link",
  "use": "foquz-icon-target-link-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-target-link\"><path d=\"M14 11.333V12.4a1.6 1.6 0 01-1.6 1.6H3.6A1.6 1.6 0 012 12.4V3.6A1.6 1.6 0 013.6 2h1.067M10 2h4m0 0v4m0-4L8 8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol